module.exports = __webpack_public_path__ + "static/img/xsdc2.434914f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/xsdc2.png
// module id = wxSy
// module chunks = 1